import { useState } from "react";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../common/DeleteModal";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import { Badge, Button } from "react-bootstrap";
import QuickValetService from "../../../../../services/QuickValetService";
import { Translate } from "../../../../Enums/Tranlate";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({
	item,
	setItem,
	index,
	setAddModal,
	setLeaveModal,
	setShouldUpdate,
}) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const { canEdit, canDelete } = usePermissions();
	const quickValetService = new QuickValetService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.vehicle_number || "-"}</td>
			<td>{item?.client_phone || "-"}</td>
			<td>{item?.brand_model || "-"}</td>
			<td>{item?.vehicle_color || "-"}</td>
			<td>
				<Badge className="text-capitalize" variant="outline-primary">
					{lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar}
				</Badge>
			</td>
			<td className="text-wrap-mode">
				{Number(item?.price)?.toFixed(3)} {Translate[lang].kwd}
			</td>
			<td>
				<Badge
					className={`text-capitalize ${
						item.status !== "leave" ? "cursor-pointer" : ""
					}`}
					onClick={() => {
						if (item.status !== "leave") {
							setLeaveModal(true);
							setItem(item);
						}
					}}
					variant={`${
						item.status === "leave"
							? "success"
							: item.status === "reject"
								? "danger"
								: item.status === "parking"
									? "info"
									: item.status === "pending" || item.status === "prepare_car"
										? "warning"
										: "secondary"
					} light`}>
					{Translate[lang][item?.status]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{/* {item.status !== "leave" && (
						<i
							tooltip="Leave Car"
							className="la la-car-side fs-26 cursor-pointer"
							onClick={() => {
								setLeaveModal(true);
								setItem(item);
							}}
						/>
					)} */}
					{canEdit("quick_valet") && (
						<img
							src={editIcon}
							className="cursor-pointer"
							onClick={() => {
								setAddModal(true);
								setItem(item);
							}}
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("quick_valet") && (
						<img
							src={trashIcon}
							className="cursor-pointer"
							onClick={() => setDeleteModal(true)}
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.vehicle_number || item?.client_phone}
					deletedItem={item}
					modelService={quickValetService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
